export const labelClassNames = ["text-xs", "leading-3"];
export const sectionTitleClass = ["font-semibold", "text-sm", "leading-5", "mb-4"];
